import {Stack, Typography,Box, useTheme} from "@mui/material";
import RpIcon from "@/components/RpIcon";
import AppModal from "@/components/AppModal";
import React, {useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {useBoolean, useNetwork} from "ahooks";
import mobileClasses from "./mobile.module.css";
import {useSelector} from "react-redux";
import AppLoadingButton from "@/components/mui/LoadingButton";
import {alpha} from "@mui/material/styles";
interface Props {
  variety: any,
  depositInfo: any,
  onSelected: (network: any) => void
}

const SelectNetwork = (props: Props) => {
  const { variety, depositInfo, onSelected, autoShow } = props;
  const {t} = useTranslation();

  const theme = useTheme()

  const [selected, setSelected] = useState(null);
  const [networkModalShow, networkModalShowOperate] = useBoolean(false);

  useEffect(() => {
    if (autoShow && depositInfo?.addressList.length > 0 && !selected) {
      networkModalShowOperate.setTrue()
    }
  }, [depositInfo?.addressList, selected]);

  return (
    <>
      <Box className={'span'} sx={{marginBottom:"6px"}}>{t('network')}</Box>
      <Stack
        sx={theme => {
          return {
            height: 48,
            padding: '0 16px',
            border: `0.5px solid ${alpha(theme.palette.text.secondary, 0.4)}`,
            width: `100%`,
            borderRadius:"6px"
          }
        }}
        onClick={() => { networkModalShowOperate.setTrue() }}
        direction="row" alignItems="center" justifyContent="space-between">
        <Typography fontSize={'16px'}>{selected ? selected.displayName : t("please_select_network")}</Typography>
        <RpIcon
          icon="arrow-down-simple" />
      </Stack>
    <AppModal
    open={networkModalShow}
    onClose={networkModalShowOperate.setFalse}
    >
      <Stack className={mobileClasses.modal}>
        <Stack direction="row" className={mobileClasses.modalHeader}>
          <RpIcon icon={'close'} size={18} clickable onClick={() => { networkModalShowOperate.setFalse() }} />
          <Typography sx={{fontSize:'16px',fontWeight:500}} className={mobileClasses.modalTitle}>{t('deposit')} {variety?.shortName}</Typography>
        </Stack>
        <Stack direction="column" alignItems="center" className={mobileClasses.modalContent}>
          <Stack gap="16px" direction="column" alignItems="center" className={mobileClasses.topBlock}>
            {variety && <img src={`/images/coin/${variety.varietyCode.toLowerCase()}.svg`}
                             alt={`${variety.shortName}.png`}/>}
            <Box>
              <Typography
                sx={theme => ({
                  fontSize: theme.typography.pxToRem(28),
                  fontWeight: 700,
                  lineHeight: 'normal',
                  textAlign: 'center'
                })}
              >{t('select_a_network')}</Typography>
              <Typography
                sx={theme => ({
                  fontSize: theme.typography.pxToRem(12),
                  fontWeight: 500,
                  color: theme.palette.text.secondary,
                  marginTop: '8px',
                  textAlign: 'center'
                })}
                align="center">{t('select_a_network_ensure')}</Typography>
            </Box>
          </Stack>
          <Stack sx={{width:'100%', padding: '16px'}}>
            <Box className={'h4'} sx={{marginBottom:'16px',marginTop:'32px'}}>{t('network')}</Box>
            <Stack gap="16px">
              {depositInfo &&
                depositInfo.addressList.map(_ => {
                  return (
                    <Stack
                      direction="column"
                      justifyContent="center"
                      key={_.coin}
                      onClick={() => {
                        setSelected(_)
                        networkModalShowOperate.setFalse()
                        onSelected && onSelected(_)
                      }}
                      sx={theme => {
                      return {
                        paddingLeft: '16px',
                        height: '72px',
                        borderRadius: '2px',
                        backgroundColor: theme.palette.background.card,
                        position: 'relative',
                        overflow: 'hidden',
                        border: `1px solid transparent`,
                        borderColor: (selected && selected.coin == _.coin) ? theme.palette.text.primary : theme.palette.background.other1,
                        borderWidth: (selected && selected.coin == _.coin) ? '2px' : '1px',
                        cursor:"pointer"
                      }
                    }}>
                      {(selected && selected.coin == _.coin) &&
                        <>
                          <Stack
                          sx={{position: 'absolute', right: 0, top: 0,
                          width: '40px', height: '40px'
                          }}
                          >
                            <img
                              style={{position: 'absolute', right: -7, top: -7}}
                              src={`/images/rectangle.svg`}/>
                            <Box
                              sx={{position: 'absolute', right: 0, left: 0, zIndex: 3,
                                width: '40px', height: '40px',
                                textAlign: 'center',
                              }}
                            >
                              <i
                                style={{
                                  fontSize: '22px',
                                  height: '22px',
                                  lineHeight: '22px',
                                  color: theme.palette.background.default,
                                  position: 'absolute',
                                  right: 0,
                              }}
                                color={theme.palette.background.default} className="iconfont icon-check" />
                            </Box>


                          </Stack>
                        </>
                      }
                      <Stack>
                        <Typography
                          sx={theme => {
                            return {
                              fontSize: theme.typography.pxToRem(14),
                            }
                          }}
                        >{variety?.shortName} - {_.displayName}</Typography>
                        <Typography
                          sx={theme => {
                            return {
                              fontSize: theme.typography.pxToRem(12),
                              color: theme.palette.text.secondary
                            }
                          }}
                        >
                          {t('minimum_deposit_amount')}: {depositInfo.depositMin} {variety?.shortName}
                        </Typography>
                        <Typography
                          sx={theme => {
                            return {
                              fontSize: theme.typography.pxToRem(12),
                              color: theme.palette.text.secondary
                            }
                          }}
                        >
                          {t('deposit_arrival_confirmations', { confirmations: _.confirmations })}
                        </Typography>
                      </Stack>
                    </Stack>
                  )
                })
              }
            </Stack>

          </Stack>
        </Stack>
      </Stack>

    </AppModal>
    </>

  )
}

export default SelectNetwork;